import { render, staticRenderFns } from "./PresentationScreen.vue?vue&type=template&id=5850d9b4&scoped=true&"
import script from "./PresentationScreen.vue?vue&type=script&lang=ts&"
export * from "./PresentationScreen.vue?vue&type=script&lang=ts&"
import style0 from "./PresentationScreen.vue?vue&type=style&index=0&id=5850d9b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850d9b4",
  null
  
)

export default component.exports